import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {HeaderState} from './HeaderState.interface';

const INITIAL_HEADER_STATE: HeaderState = {
  title: '',
  customTitle: undefined,
  customTiaraObject: undefined,
  mobile: {
    isExposed: false,
    currentMobileHeaderType: undefined,
  },
  shouldCheckRequiredAgreement: false,
  hideBackButton: false,
};

export const headerSlice = createSlice({
  name: 'header',
  initialState: INITIAL_HEADER_STATE,
  reducers: {
    setHeader: (state, action: PayloadAction<HeaderState>): void => {
      Object.assign(state, {...action.payload});
    },
    initializeHeader: (state): void => {
      Object.assign(state, {...INITIAL_HEADER_STATE});
    },
    setShouldCheckRequiredAgreement: (
      state,
      action: PayloadAction<{shouldCheckRequiredAgreement: boolean}>
    ): void => {
      state.shouldCheckRequiredAgreement =
        action.payload.shouldCheckRequiredAgreement;
    },
  },
});

export const {setHeader, initializeHeader, setShouldCheckRequiredAgreement} =
  headerSlice.actions;
